module.exports = "/_next/static/images/208010f0b484ed53f59711873ef0fdfc-holding-card-vertical@3x.png.webp";